module.exports = __webpack_public_path__ + "img/text.a98dc5f3.png";